import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import { BulkAction, ModalService, DataService } from "@bb-vendure/admin-ui/core";
import {
  DeleteDefaultInfoDocument,
  DeleteDefaultInfoMutation
} from "src/generated-gql/graphql";

const deleteBulkAction: BulkAction = {
  location: "default-info-table",
  label: "Delete Selected Product type",
  icon: "trash",
  iconClass: "is-danger",
  requiresPermission : (userPermissions) => {
    return userPermissions.includes('DeleteDefaultProductInformation')
  },
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete Selected Default product informations",
        body: `Are you sure you want to delete ${selection.length} default informations?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteDefaultInfoMutation>[] = [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteDefaultInfoDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteBulkAction };
